export const isValidSelectedControls = (selections: string | null): selections is string => {
    if (!selections) return false;
    try {
        const parsedSelections = JSON.parse(selections);
        return Array.isArray(parsedSelections) && parsedSelections.length > 0;
    } catch {
        return false;
    }
};
